import Joi from '@hapi/joi';
import React from 'react';
import { Nen3140Score } from '../../../../common/src/domain/customInspectionTypes/nen3140/Nen3140Score';
import { nen3140ScoreToConditionScore } from '../../../../common/src/domain/customInspectionTypes/nen3140/nen3140ScoreToConditionScore';
import { CollapsiblePanel, EditPanel, EditPanelButtons, EditPanelCell, EditPanelRow, EditPanelSection, PanelBody } from '../../components/elements';
import {
    ValidatingEditPanelSaveButton,
    ValidatingFilterDropdown,
    ValidatingForm,
    ValidatingFormContext,
    ValidatingFormTextArea,
} from '../../components/validatingElements';
import { useTranslate } from '../../mixins/translate/translate';
import { nen3140SelectOptions } from './nen3140SelectOptions';

export function SurveyEditNen3140SummaryAndAdvice(props: { surveyId: string }) {
    const translate = useTranslate();

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: 'Samenvatting' }}>
                <ValidatingForm schema={Joi.object()} itemUrl={`/api/surveys/${props.surveyId}`} id={props.surveyId} showSavedToast>
                    <PanelBody isForm={true}>
                        <EditPanelRow>
                            <EditPanelCell rowCount={4}>
                                <ValidatingFormContext.Consumer>
                                    {() => (
                                        <ValidatingFilterDropdown
                                            name="condition"
                                            selectOptions={nen3140SelectOptions.nen3140Score.map((i) => ({
                                                text: i.text,
                                                value: nen3140ScoreToConditionScore(i.value as Nen3140Score),
                                            }))}
                                        />
                                    )}
                                </ValidatingFormContext.Consumer>
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelSection>
                            <ValidatingFormTextArea name="summaryAndAdvice" placeholder={translate('survey.composeSummaryAndAdvice')} size="s" />
                        </EditPanelSection>

                        <EditPanelButtons>
                            <ValidatingEditPanelSaveButton small={true} />
                        </EditPanelButtons>
                    </PanelBody>
                </ValidatingForm>
            </CollapsiblePanel>
        </EditPanel>
    );
}
